import ModalystOrderPaymentModal from './ModalystOrderPaymentModal'

export default ModalystOrderPaymentModal
